import React from "react";
import { string, func, arrayOf, shape, bool, any } from "prop-types";

const SelectListGroup = ({
  value,
  onChange,
  onBlur,
  options,
  id = "",
  classes = "",
  isError = false,
  isBold = false,
  isDisabled = false,
}) => {
  const selectOptions = options.map((option) => (
    <option key={option.label} value={option.value}>
      {option.label}
    </option>
  ));

  return (
    <select
      id={id}
      className={`${classes} form-control member-input-dropdown`}
      defaultValue={selectOptions[0].value}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={isDisabled}
      style={{
        border: isError ? "1px solid red" : "",
        fontWeight: isBold ? "bold" : "",
        paddingRight: "1.3rem",
        opacity: !value ? 0.5 : 1,
      }}
    >
      {selectOptions}
    </select>
  );
};

SelectListGroup.propTypes = {
  id: string.isRequired,
  value: string,
  onChange: func.isRequired,
  onBlur: func,
  options: arrayOf(
    shape({
      label: string.isRequired,
      value: any.isRequired,
    })
  ).isRequired,
  classes: string,
  isError: bool,
  isBold: bool,
  isDisabled: bool,
};

export default SelectListGroup;
